import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import './cimage.css';

// Solo importar la primera imagen
import primeraImagen from "../img/img-renders/RENDER 3.png";

const MediaGallery = () => {
  const navigate = useNavigate();
  
  // Configuración de medios sin importaciones
  const mediaConfig = [
    { title: 'BANCAS', filename: 'RENDER 3.png' },
    { title: 'SILLAS DE COMEDOR', filename: 'RENDER 6.png' },
    { title: 'SILLAS DE BAR', filename: 'RENDER 4.png' },
    { title: 'SILLAS PARA DIFERENTES AMBIENTES', filename: 'RENDER 7.png' },
    { title: 'BANCAS AMBIENTALES', filename: 'RENDER 5.png' },
    { title: 'SILLAS ENREJILLADAS', filename: 'RENDER 8.png' },
    { title: 'BANCAS EN DIFERENTES MEDIDAS', filename: 'RENDER 3.png' }
  ];

  const [currentMediaIndex, setCurrentMediaIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState(true);
  const [loadedImages, setLoadedImages] = useState({ 0: primeraImagen });
  const [imageCache, setImageCache] = useState({});

  // Función para cargar imagen bajo demanda
  const cargarImagen = useCallback(async (index) => {
    if (loadedImages[index]) return loadedImages[index];
    
    try {
      const filename = mediaConfig[index].filename;
      const image = await import(`../img/img-renders/${filename}`);
      setLoadedImages(prev => ({ ...prev, [index]: image.default }));
      return image.default;
    } catch (error) {
      console.warn(`Error cargando imagen ${index}:`, error);
      return primeraImagen; // Fallback a la primera imagen
    }
  }, [loadedImages, mediaConfig]);

  // Precargar imágenes estratégicamente
  useEffect(() => {
    // Cargar imagen actual
    cargarImagen(currentMediaIndex);
    
    // Precargar siguiente imagen
    const nextIndex = (currentMediaIndex + 1) % mediaConfig.length;
    cargarImagen(nextIndex);
  }, [currentMediaIndex, cargarImagen, mediaConfig.length]);

  // Auto-play
  useEffect(() => {
    let interval;
    if (isPlaying) {
      interval = setInterval(() => {
        setCurrentMediaIndex((prevIndex) => 
          prevIndex === mediaConfig.length - 1 ? 0 : prevIndex + 1
        );
      }, 5000);
    }
    return () => clearInterval(interval);
  }, [isPlaying, mediaConfig.length]);

  const nextMedia = () => {
    setCurrentMediaIndex((prevIndex) => 
      prevIndex === mediaConfig.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevMedia = () => {
    setCurrentMediaIndex((prevIndex) => 
      prevIndex === 0 ? mediaConfig.length - 1 : prevIndex - 1
    );
  };

  const selectMedia = async (index) => {
    setCurrentMediaIndex(index);
    await cargarImagen(index);
  };

  const handleVerRevista = () => {
    navigate('/magazine');
  };

  const currentMedia = mediaConfig[currentMediaIndex];
  const currentImageSrc = loadedImages[currentMediaIndex] || primeraImagen;

  return (
    <section className="media-gallery">
      <div className="gallery-container">
        <div className="main-media">
          <img 
            src={currentImageSrc}
            alt={currentMedia.title}
            className="gallery-media"
            loading="lazy"
          />
          
          <div className="media-overlay">
            <h3>{currentMedia.title}</h3>
          </div>

          <button className="ver-revista-btn" onClick={handleVerRevista}>
            VER REVISTA
          </button>

          <button className="nav-btn prev-btn" onClick={prevMedia}>
            ‹
          </button>
          <button className="nav-btn next-btn" onClick={nextMedia}>
            ›
          </button>

          <div className="progress-bar" style={{animationDuration: '5s'}}></div>
        </div>

        <div className="media-thumbnails">
          {mediaConfig.map((item, index) => (
            <div
              key={index}
              className={`thumbnail ${index === currentMediaIndex ? 'active' : ''}`}
              onClick={() => selectMedia(index)}
            >
              <img 
                src={loadedImages[index] || primeraImagen} 
                alt={item.title}
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MediaGallery;